export const TEACHER_PALETTE: readonly string[] = ['#2563eb', '#16a34a', '#db2777', '#d97706', '#7c3aed', '#0891b2', '#dc2626', '#4f46e5'];

export interface TeacherLike {
  id: string;
  user: { fullName?: string | null; email: string };
  /** Set when the membership has been soft-removed — the name is still shown
   * (for historical views) but marked as a former teacher. */
  removedAt?: string | null;
}

/** Deterministic palette color from a membership id (stable across renders). */
export function teacherColor(membershipId: string): string {
  let hash = 0;
  for (let i = 0; i < membershipId.length; i++) hash = (hash * 31 + membershipId.charCodeAt(i)) >>> 0;
  return TEACHER_PALETTE[hash % TEACHER_PALETTE.length] ?? TEACHER_PALETTE[0]!;
}

export function resolveTeacher(members: TeacherLike[], teacherId: string | null | undefined): { name: string; color: string } | null {
  if (!teacherId) return null;
  const m = members.find((x) => x.id === teacherId);
  if (!m) return null;
  const baseName = m.user.fullName || m.user.email;
  const name = m.removedAt ? `${baseName} (cựu GV)` : baseName;
  return { name, color: teacherColor(m.id) };
}
